import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addWaasSuiExtension } from '../waas/addWaasSuiExtension';
import { addSuiWalletStandardExtension } from '../walletStandard/addSuiWalletStandardExtension';

/**
 * Adds the Sui extension to the Dynamic client.
 *
 * This is a convenience function that adds both the Sui Wallet Standard extension
 * and the Dynamic WaaS Sui extension, enabling support for all Sui wallet types
 * including standard wallets and embedded wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addSuiExtension = (client = getDefaultClient()): void => {
  addSuiWalletStandardExtension(client);
  addWaasSuiExtension(client);
};
